import React, { useEffect, useState, useContext } from "react";
import { useQuery } from 'react-query';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { awaitingRegionalApprovals, searchApplication } from "../../../api/apiServices";
import Pagination from '../../../services/Pagination';
import 'react-confirm-alert/src/react-confirm-alert.css';
import toast, { Toaster } from 'react-hot-toast'
import AuthContext from "../../../context/AuthProvider";

const RegionalApprovals = () => {

    const { auth } = useContext(AuthContext)
    const params = useParams();
    const id = params.id ? params.id : undefined

    const [search, setSearch] = useState(false);
    const [regApplication, setRegApplication] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(15);

    const {
        isLoading,
        isError,
        error,
        data: regApproval,
    } = useQuery(['regApproval', auth.email], () => awaitingRegionalApprovals(auth.email), {
        select: data => data.sort((a, b) => b.id - a.id),
        keepPreviousData: true,
    });

    let total_applications = regApproval?.length

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/regional_approvals";


    const [mobile_number, setMobileNumber] = useState(null);
    const [first_name, setFirstName] = useState(null);
    const [last_name, setLastName] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();

        const searchData = {
            mobile_number: mobile_number,
            first_name: first_name,
            last_name: last_name,
        }

        try {
            await searchApplication(searchData).then((res) => {
                if (res.length > 0) {
                    setRegApplication(res)
                    setSearch(true)
                    setMobileNumber(null)
                    setFirstName(null)
                    setLastName(null)
                }
            }).catch((err) => {
                toast.error("Provide at least one search parameter ")
                return false
            })
        } catch (err) {
            toast.error(err)
        }
    }

    let currentPosts = []
    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    if (!search) {
        currentPosts = regApproval?.slice(indexOfFirstPage, indexOfLastPage);
    } else {
        currentPosts = regApplication?.slice(indexOfFirstPage, indexOfLastPage);
    }

    const handleCancel = () => {

        setMobileNumber("");
        setFirstName("");
        setLastName("");
        setSearch(false);
        navigate(from, { replace: true });
    }

    let searchContent = (
        <form onSubmit={handleSearch} >
            <div className="form-group row">
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        // style={{ textTransform: "uppercase" }}
                        placeholder="Mobile Number"
                        onChange={(e) => setMobileNumber(e.target.value)}
                        value={mobile_number}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="FirstName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={first_name}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="LastName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setLastName(e.target.value)}
                        value={last_name}
                    />
                </div>
                <div className="col-sm-3">
                    <button
                        type="submit"
                        className="btn btn-success btn-block"
                    > <i className="fa fa-search"></i> Search Application
                    </button>
                </div>
            </div>
        </form>
    )

    let content
    if (isLoading) {
        content = <p>Loading Regional Applications...</p>
    }
    else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            currentPosts && currentPosts?.length <= 0 ? (
                <div className="table-responsive lg">
                    <table className="table table-borderless table-striped">
                        <tbody>
                            <tr>
                                <td style={{ fontSize: "20px", fontWeight: "700", color: "#000", textAlign: "center" }}>
                                    There are no pending regional approval(s)
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <div className="table-responsive lg">
                    <table className="table table-borderless table-striped">
                            <thead className="align">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Full Name</th>
                                    <th scope="col">Region</th>
                                    <th scope="col">Mobile</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPosts?.map((mem, index) => <tr key={index}>
                                    <td>{postPerPage * (currentPage - 1) + index + 1}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{mem.title}&nbsp;{mem.first_name}&nbsp;{mem.middle_name}&nbsp;{mem.last_name}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{mem.region}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{mem.mobile_number}</td>
                                    <td>{mem.email}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>
                                        <div style={{ display: 'inline-block' }}>
                                            <Link to={`/view_application/${mem.id}`} className="small"> <i className='fa fa-eye'></i> View</Link>
                                        </div>&nbsp; &nbsp;
                                        <div style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
                                            <Link to={`/regional_approve_form/${mem.id}`} className="small"> <i className='fa fa-key'></i> Approval</Link>
                                        </div>&nbsp;&nbsp;
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            )
    }


    return (
        <><section className="content-header">
            <Toaster toastOptions={{ position: "top-center" }} />
            <h1>Applications : Pending Regional Approval - {total_applications}</h1>
        </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span> {currentPosts && currentPosts?.length > 0 ? searchContent : null}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                {currentPosts?.length > 0 && !search ? (
                                    <Pagination
                                        data={regApproval}
                                        postPerPage={postPerPage}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        setPostPerPage={setPostPerPage} />
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="box-body"></div>
                </div>
            </section></>
    );
}

export default RegionalApprovals;


